
import { useContext, useEffect, useState } from 'react'
import { CButton, CCard, CCardBody, CCardHeader, CCol, CCollapse, CRow } from '@coreui/react-pro';
import ScrollToTop from 'react-scroll-to-top';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AppContext } from '../../contexts/App';
import CIcon from '@coreui/icons-react';
import { cilArrowTop, cilPlus, cisChevronBottom, cisChevronTop } from '@coreui/icons-pro';
import FilterSorting from './componenet.filter.sorting';
import Table from './componenet.table';

export default function Index() {
    const { setMetaData, theme } = useContext(AppContext)
    const [searchParams] = useSearchParams();
    const navigate = useNavigate()
    const [collapseFilterSorting, setCollapseFilterSorting] = useState(searchParams.has('piutang') ||
        searchParams.has('date_pinjam_after') ||
        searchParams.has('date_pinjam_before') ||
        searchParams.has('date_kembali_after') ||
        searchParams.has('date_kembali_before') ||
        searchParams.has('is_active') ||
        searchParams.has('ordering')
    )

    useEffect(() => {
        setMetaData({
            title: "Piutang",
        })
    }, [setMetaData])

    return (<>
        <CRow>
            <CCol md={12}>
                <CButton color={'primary'} size='sm' className='me-2 mb-3' onClick={() => {
                    navigate({ pathname: "add" })
                }}><CIcon icon={cilPlus} className='me-1' />Add</CButton>
                <CButton active={collapseFilterSorting} color={'primary'} size='sm' className='me-2 mb-3' onClick={() => {
                    setCollapseFilterSorting(x => !x)
                }}> Filter & Sorting <CIcon className='ms-1' icon={collapseFilterSorting ? cisChevronBottom : cisChevronTop} /></CButton>
            </CCol>
        </CRow>

        <CCollapse visible={collapseFilterSorting}>
            <CRow className='mb-3'>
                <CCol>
                    <CCard>
                        <CCardHeader>
                            Filter & Sorting
                        </CCardHeader>
                        <CCardBody>
                            <FilterSorting />
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
        </CCollapse>
        <CRow>
            <CCol>
                <CCard>
                    <CCardBody>
                        <Table />
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <ScrollToTop smooth component={<CIcon icon={cilArrowTop} />} className={`rounded-circle bg-${theme}`} />
    </>)
}
